import api from "../utils/api";
import { buildAnalyticsSearchParams } from "./analyticsParams";

export async function getActivity(filters = {}) {
  const params = buildAnalyticsSearchParams(filters);

  return (
    await api.get(
      `/api/admin/activity?${params.toString()}`,
    )
  ).data;
}
